import Commitmens from './Commitmens';
export default Commitmens;
